<div class="container-fluid px-0">
    <div class="row">
        <div class="col-sm-12">

            <div class="card mb-4">
                <div class="card-header">Detalle de mi cuenta <input type="button" (click)="openPass(chpass,'md')"
                        class="btn btn-sm btn-danger mt-2 mb-2 w-20 float-right" value="Cambiar contraseña" /></div>
                <div class="card-body">
                    <form novalidate [formGroup]="userForm" (ngSubmit)="update()">

                        <div class="row gx-3 mb-3">
                            <div class="col-md-6">
                                <label for="name" class="form-label small">Primer nombre</label>
                                <input type="text" class="form-control" style="text-transform: uppercase;" id="name"
                                    placeholder="Nombre" formControlName="name">
                            </div>
                            <div class="col-md-6">
                                <label for="lastname" class="form-label small">Apellidos</label>
                                <input type="text" class="form-control" style="text-transform: uppercase;" id="lastname"
                                    placeholder="Apellidos" formControlName="lastname">
                            </div>
                        </div>
                        <div class="row gx-3 mb-3">
                            <div class="col-md-6">
                                <label class="small mb-1" for="position">Cargo</label>
                                <input class="form-control" id="position" type="text" placeholder="Cargo o profesion"
                                    formControlName="position">
                            </div>
                            <div class="col-md-6">
                                <label class="small mb-1" for="privilege">Privilegio</label>
                                <input class="form-control" id="position" type="text" placeholder="Cargo o profesion"
                                    formControlName="privilege">
                            </div>
                        </div>
                        <div class="row gx-3 mb-3">
                            <div class="col-md-6">
                                <label class="small mb-1" for="email">Dirección de correo</label>
                                <input id="email" type="email" class="form-control" style="text-transform: lowercase;"
                                    id="name" placeholder="Correo electronico" formControlName="email">
                            </div>
                            <div class="col-md-6">
                                <label class="small mb-1" for="inputBirthday">Telefono</label>
                                <input type="tel" class="form-control" max="10" id="lastname"
                                    placeholder="Telefono / celular" formControlName="phone">
                            </div>
                        </div>
                        <input type="submit" class="btn  btn-primary" value="Actualizar" />
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #chpass let-c="close" let-d="dismiss">
    <form (submit)="updatePass()" novalidate [formGroup]="passForm">
        <div class="card">
            <div class="card-header text-center" style="text-transform: uppercase">
                MODIFICAR CONTRASEÑA

                <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <div class="mb-2">
                            <label for="pass" class="form-label">Contraseña Actual</label>
                            <input type="password" class="form-control" style="text-transform: uppercase;" id="pass"
                                placeholder="" formControlName="pass">
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="mb-2">
                            <label for="npass" class="form-label">Nueva contraseña</label>
                            <app-input-password-generate
                            (selectedValue)="passForm.get('npass')?.setValue($event)"
                            [class]="'form-control'"
                          />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="mb-1">
                            <label for="rpass" class="form-label">Repita contraseña</label>
                            <input type="password" class="form-control" max="4" id="rpass" placeholder=""
                                formControlName="rpass">
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="d('Cross click')">Cancelar</button>
                <input type="submit" name="make_payment" class="btn  btn-primary mt-2 mb-2 w-50" style="float: right;"
                    value="Cambiar" />
            </div>
        </div>
    </form>
</ng-template>

<ng-template #repo let-c="close" let-d="dismiss">
    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <app-repository-image (onSelected)="userForm.get('image')?.setValue($event?.link)" />
    </div>
</ng-template>